export default __webpack_public_path__ + "static/media/monkey_white_male.8fda7b8a.png";